
	<div class="header" [class.invislbe]="!hasLoaded">
		<div class="content">
			<div class="contentInner">
				<div class="pageTitle" appReveal>
				<h1 class="headline">The simple meeting room display and booking system</h1>
        <p class="tagline">See what's on, book the room in one tap, and free up no-shows automatically. Dash runs on the hardware you already own, or on purpose-built PoE panels with LED status lights.</p>
          <p class="priceMessage">Free read-only display forever. Room booking and more for $3.99 per display per month, with your first month free.</p>
          <div class="storeButtonContainer">
				  <div>
            <a href="https://apps.apple.com/us/app/dash-meeting-room-display/id1481443382" (click)="plausible.trackClick($event, 'App Store Click')"><img ngSrc="../assets/images/app-store-badge.svg" width="133" height="40" alt="Download on App Store"></a>
            <a href="https://play.google.com/store/apps/details?id=nz.co.aptsoftware" (click)="plausible.trackClick($event, 'Play Store Click')"><img ngSrc="../assets/images/play-store-badge.svg" width="133" height="40" alt="Download on Play Store"></a>
          </div>
          <div>
            <a href="https://www.amazon.com/gp/product/B0D4DY15WY" (click)="plausible.trackClick($event, 'Amazon Store Click')"><img ngSrc="../assets/images/amazon-store-badge.svg" width="133" height="40" alt="Download on Amazon App Store"></a>
            <a routerLink="/enterprise/web-app"><img ngSrc="../assets/images/web-badge.svg" width="133" height="40" alt="Available as a web app"></a>
          </div>
				</div>
				</div>
<!--				<div class="heroContainer" [ngsRevealSet]="{ reset:false, origin: 'right', scale:1, distance: '100px'}" [ngsInterval]="50" [ngsSelector]="'.hero'">-->
					<app-hero class="hero"></app-hero>
<!--				</div>-->
			</div>
		</div>
	</div>

  <div class="content tagContent" [class]="!hasLoaded? 'invisible' : null">
    <div class="contentInner">
      <div class="section tagSection">
        <h2 class="tagline">Dash has everything you need, and nothing you don't.</h2>
        <div class="tagRow">
          <div class="tagItem calendar"><div class="icon"></div>Uses your existing calendar system</div>
          <div class="tagItem noHardware"><div class="icon"></div>No hardware lock-in</div>
        </div>
        <div class="tagRow">
          <div class="tagItem fullyFeatured"><div class="icon"></div>Fully featured</div>
          <div class="tagItem padlock"><div class="icon"></div>We never see your meeting schedule</div>
        </div>
      </div>
    </div>
  </div>

	<div class="content" [class]="!hasLoaded? 'invisible' : null">
<!--		<div class="contentInner">-->


		<div class="section">
      <div class="sectionInner">
        <div class="section1" appReveal>
          <h2 class="sectionHeader">Works with your calendars</h2>
          <p>Dash works directly with Microsoft 365, Google Workspace, or the calendars on your phone or tablet.  Book from your desk with Outlook or Google Calendar; book from the room with your Dash display.  Dash is available in 26 languages.</p>
          <p>We support any provider that you can display in the calendar app on your device.</p>
          <p><strong>Exchange or Microsoft 365?&nbsp;&nbsp;No problem!</strong></p>
          <p><strong>Google Workspace?&nbsp;&nbsp;Easy!</strong></p>
          <a class="button" routerLink="/features" fragment="calendar">Explore calendar integrations</a>
        </div>
        <div class="spacer"></div>
        <div class="section2 image">
          <div class="pageImage worksWithYouImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
      </div>
		</div>

    <div class="section">
      <div class="sectionInner">
        <div class="section1 image">
          <div class="pageImage hardwareImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
        <div class="spacer"></div>
        <div class="section2" appReveal>
          <h2 class="sectionHeader">Runs on your hardware</h2>
          <p style="clear:both;margin-top: 35px;">Run Dash as a native app on almost any iPad, Android tablet, or smartphone; or run it as a web app on a smart TV or any screen with a modern web browser.</p>
          <p>If you need a purpose-built solution, PoE scheduling panels from partners like PoE Texas arrive with Dash preinstalled, and other professional panels are supported (including LED status lights).</p>
          <p><strong>Spare iPad in a drawer?&nbsp;&nbsp;Perfect.</strong></p>
          <p><strong>PoE panel on the wall?&nbsp;&nbsp;Preinstalled.</strong></p>
          <a class="button" routerLink="/hardware">Explore supported hardware</a>
        </div>
      </div>
    </div>

		<div class="section">
      <div class="sectionInner">
        <div class="section1" appReveal>
          <h2 class="sectionHeader">Room status at a glance</h2>
          <p>Easily see whether a room is free, even from far away.  Up close, get a detailed schedule for the day so you always know what's on.</p>
          <p>Customize what is displayed on screen so that sensitive meeting names stay hidden.</p>
          <a class="button" routerLink="/features" fragment="display">Explore the Dash display</a>
        </div>
        <div class="spacer"></div>
        <div class="section2 image">
          <div class="pageImage statusAtAGlanceImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
      </div>
		</div>

		<div class="section">
      <div class="sectionInner">
        <div class="section1 image">
          <div class="pageImage bookingMadeEasyImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
        <div class="spacer"></div>
        <div class="section2" appReveal>
          <h2 class="sectionHeader">Room booking made easy</h2>
          <p>Book a room in one touch, directly from the screen.</p>
          <p>Someone else got there first?  Find a free conference room close by and book it on the spot, so you don't have to go back to your desk.</p>
          <a class="button" routerLink="/features" fragment="booking">Explore booking features</a>
        </div>
      </div>
		</div>

		<div class="section">
      <div class="sectionInner">
        <div class="section1" appReveal>
          <h2 class="sectionHeader">No more no-shows or wasted rooms</h2>
          <p>End a meeting early from the screen, so that the room is free in your schedule.</p>
          <p>You can require participants to check in to a meeting when they arrive.  If no one has checked in ten minutes after the start time, Dash ends the meeting and frees up the space automatically.</p>
          <a class="button" routerLink="/features" fragment="booking">See check-in & auto-release</a>
        </div>
        <div class="spacer"></div>
        <div class="section2 image">
          <div class="pageImage noMoreEmptyRoomsImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
      </div>
		</div>

		<div class="section">
      <div class="sectionInner">
        <div class="section1 image">
          <div class="pageImage brandingImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
        <div class="spacer"></div>
        <div class="section2" appReveal>
          <h2 class="sectionHeader">Your brand in front</h2>
          <p>Your brand is important.  Dash makes it easy to customize colorschemes and imagery so that guests see your brand, not ours.</p>
          <p><strong>Beautiful.&nbsp;&nbsp;&nbsp;&nbsp;Professional.&nbsp;&nbsp;&nbsp;&nbsp;Easy.</strong></p>
          <a class="button" routerLink="/features" fragment="branding">Explore branding options</a>
        </div>
      </div>
		</div>

    <div class="section">
      <div class="sectionInner">
        <div class="section1 image">
          <div class="pageImage analyticsImage" appGalleryScroll [alpha]="false" scaleFactor="10" minWidth="950"></div>
        </div>
        <div class="spacer"></div>
        <div class="section2" appReveal>
          <h2 class="sectionHeader">Unlock more with Dash Enterprise</h2>
          <p>Need more?</p>
          <p>Upgrade to a Dash Enterprise subscription to centrally manage and configure your Dash display devices, and gain unique insights into your meeting rooms with our advanced analytics.</p>
          <a class="button" routerLink="/about-enterprise">Learn more about Dash Enterprise</a>
        </div>
      </div>
    </div>

<!--		</div>-->
	</div>
	<div class="bottomSection" [class]="!hasLoaded? 'invisible' : null">
			<div class="content">
				<div class="contentInner">
					<div class="callToAction">
						<h2 class="sectionHeader">Get it now</h2>
            <p>Free read-only display forever. Try room booking and more free for one month, then $3.99 per display per month.</p>
					</div>
					<div class="spacer" ></div>
					<div class="storeButtonContainer">
            <div>
              <a href="https://apps.apple.com/us/app/dash-meeting-room-display/id1481443382" (click)="plausible.trackClick($event, 'App Store Click')"><img ngSrc="../assets/images/app-store-badge.svg" width="133" height="40" alt="Download on App Store"></a>
              <a href="https://play.google.com/store/apps/details?id=nz.co.aptsoftware" (click)="plausible.trackClick($event, 'Play Store Click')"><img ngSrc="../assets/images/play-store-badge.svg" width="133" height="40" alt="Download on Play Store"></a>
            </div>
            <div>
              <a href="https://www.amazon.com/gp/product/B0D4DY15WY" (click)="plausible.trackClick($event, 'Amazon Store Click')"><img ngSrc="../assets/images/amazon-store-badge.svg" width="133" height="40" alt="Download on Amazon App Store"></a>
              <a routerLink="/enterprise/web-app"><img ngSrc="../assets/images/web-badge.svg" width="133" height="40" alt="Available as a web app"></a>
            </div>
					</div>
				</div>
			</div>
	</div>

<!--  <div class="loaderContainer" *ngIf="!hasLoaded">-->
<!--    <div class="loader"></div>-->
<!--    <img ngSrc="../assets/images/ipad-screen.webp" priority width="1" height="1" class="hiddenImage" (load)="countLoadedImage($event)" fetchpriority="high">-->
<!--  </div>-->
